<template>
    <div>
        <div v-if="loading" class="lds-dual-ring"></div>
        <div class="row" v-if="!loading">
            <div class="col-lg-12 mb-4">
                <EmployeeInfoBlock
                    :user="dataEmployeeInfoBlock"
                ></EmployeeInfoBlock>
            </div>
            <div class="col-lg-12 mb-4 p-0">
                <TabsContainer
                    v-if="user"
                    :user-status="userStatus"
                    :user="user"
                    :user-id="user.id"
                ></TabsContainer>
            </div>
        </div>
    </div>

</template>

<script>
import EmployeeInfoBlock from "./EmployeeInfoBlock.vue";
import TabsContainer from "./TabsContainer.vue";
import EmployeeInfoService from "../services/EmployeeInfoService";

export default {
    name: 'EmployeePage',
    components: {
        TabsContainer,
        EmployeeInfoBlock,
    },
    data() {
        return {
            loading: true,
            user: null,
            userStatus: null,
            dataEmployeeInfoBlock: {
                name: null,
                last_name: null,
                ssn: null,
                email: null,
                position: {
                    title: null
                },
                cell_number: null,
                user_address: {
                    city: null,
                    states: {
                        name: null
                    },
                },
                status: null
            },
        }
    },

    methods: {
        async getUserInfo() {
            try {
                const {data: userInfo} = await EmployeeInfoService.getUserInfo()
                this.user = userInfo
                this.loading = false

                Object.keys(this.dataEmployeeInfoBlock).forEach((key) => {
                    if (userInfo.hasOwnProperty(key)) {
                        this.dataEmployeeInfoBlock[key] = userInfo[key];
                    }
                });
                this.userStatus = this.user.status
            } catch (error) {
                this.$handleErrors(error);
            }
        },
    },
    mounted() {
        this.getUserInfo()
    }

}

</script>

<style scoped>

</style>
